import React from 'react'
import { Badge, Icon, IconButton, Tooltip } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useInternalCampaigns } from 'app/ducks/internalCampaigns/hooks'
import { INTERNAL_CAMPAIGNS_PATH } from 'app/ducks/internalCampaigns/constants'

/**
 * Top-bar entry point to the Novidades page, with a badge counting the
 * campaigns this user hasn't seen yet. Renders nothing when the
 * `internal_campaigns` flag is off or the user is below collaborator.
 */
const InternalCampaignsButton = () => {
  const history = useHistory()
  const { enabled, newCount } = useInternalCampaigns()

  if (!enabled) return null

  const label = newCount
    ? `Novidades (${newCount} ${newCount === 1 ? 'nova' : 'novas'})`
    : 'Novidades'

  return (
    <Tooltip title="Novidades">
      <IconButton
        aria-label={label}
        color="primary"
        className="mr-2"
        onClick={() => history.push(INTERNAL_CAMPAIGNS_PATH)}
        data-testid="internal-campaigns-button"
      >
        <Badge
          badgeContent={newCount}
          color="error"
          max={9}
          overlap="rectangular"
        >
          <Icon>auto_awesome</Icon>
        </Badge>
      </IconButton>
    </Tooltip>
  )
}

export default InternalCampaignsButton
